import styled from "styled-components";

import { largeScreen, smallScreen } from "src/shared/constants/screenSizes";

export const RecentSearchesContainer = styled.div`
  margin: 0 auto;
  max-width: 1404px;
  padding: 48px 48px 24px;

  @media screen and (max-width: ${smallScreen}px) {
    padding-left: 24px;
    padding-right: 24px;
  }
`;

export const RecentSearchItems = styled.div`
  display: flex;
  margin: 24px -12px 18px;

  @media screen and (max-width: ${largeScreen}px) {
    flex-direction: column;
    margin: 24px 0 0;
  }
`;
